(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('FrequencySearch', FrequencySearch);

    FrequencySearch.$inject = ['$resource'];

    function FrequencySearch($resource) {
        var resourceUrl =  'api/_search/frequencies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
